import { AnyAction } from "redux";
import { main } from "../constants/actionTypes";

interface initialStateInterface {
  accessToken: string;
  user: Object | null;
}

const initialState: initialStateInterface = {
  accessToken: "",
  user: null,
};

const mainReducer = (state: initialStateInterface = initialState, action: AnyAction): initialStateInterface => {
  const { type, payload } = action;

  switch (type) {
    case main.SET_USER_DATA:
      return {
        ...state,
        accessToken: payload.accessToken,
      };

    case main.SET_USER:
      return {
        ...state,
        user: payload.user,
      };

    default:
      return state;
  }
};

export default mainReducer;
